import React, { useMemo, useState } from 'react';
import { AvatarBadge } from './AvatarBadge';
import { AvatarFallback } from './AvatarFallback';
import { AvatarImage } from './AvatarImage';
import type { AvatarContextValue } from './context';
import { AvatarContext } from './context';
import type { AvatarShape, AvatarSize, ImageLoadingStatus } from './types';
import { AvatarRoot } from './view';

export interface AvatarProps {
    size: AvatarSize;
    shape?: AvatarShape;
    bgColor?: string;
    disabled?: boolean;
    className?: string;
    onClick?: (e: React.SyntheticEvent) => void;
    children?: React.ReactNode;
    'data-cy'?: string;
}

export const Avatar = ({
    size,
    shape = 'circle',
    bgColor,
    disabled,
    className,
    onClick,
    children,
    ...rest
}: AvatarProps) => {
    const [status, setStatus] = useState<ImageLoadingStatus>('idle');

    const ctx = useMemo<AvatarContextValue>(
        () => ({
            status,
            setStatus,
            bgColor,
        }),
        [status, bgColor],
    );

    return (
        <AvatarContext.Provider value={ctx}>
            <AvatarRoot
                $size={size}
                $shape={shape}
                $disabled={disabled}
                $clickable={Boolean(onClick)}
                className={className}
                onClick={onClick}
                data-cy={rest['data-cy']}
            >
                {children}
            </AvatarRoot>
        </AvatarContext.Provider>
    );
};

Avatar.Image = AvatarImage;
Avatar.Fallback = AvatarFallback;
Avatar.Badge = AvatarBadge;
